import { request } from "../http";
import {
  ensureArrayOfStrings,
  ensureBoolean,
  ensureNumber,
  ensureObject,
  ensureString,
} from "../validate";
import type { NewsletterParams } from "./newsletter";
import { privacyConsent, type PrivacyConsentParams } from "./privacy";

const FN = "GZIntegracoes.v1.sendCursosAll";

const CURSOS_ALL_UPSERT_URL =
  "https://tbcwr0ax1k.execute-api.us-east-1.amazonaws.com/prod/data-extension-and-pub-list-upsert";

const DATA_EXTENSION_KEY = "6B371801-0BDC-4234-B878-CA1ED150F93C";

export interface SendCursosAllParams {
  email: string;
  className: string;
  courseName: string;
  newsletter?: NewsletterParams;
  consent?: Omit<PrivacyConsentParams, "holder"> | null;
}

export async function sendCursosAll(params: SendCursosAllParams): Promise<boolean> {
  ensureObject(params, `${FN}(params)`);
  ensureString(params.email, `${FN} → params.email`);
  ensureString(params.className, `${FN} → params.className`);
  ensureString(params.courseName, `${FN} → params.courseName`);

  if (params.newsletter !== undefined) {
    ensureObject(params.newsletter, `${FN} → params.newsletter`);
    ensureNumber(params.newsletter.pubListId, `${FN} → params.newsletter.pubListId`);
    ensureBoolean(params.newsletter.receber, `${FN} → params.newsletter.receber`);
    ensureString(params.newsletter.code, `${FN} → params.newsletter.code`);
  }

  if (params.consent !== undefined && params.consent !== null) {
    ensureObject(params.consent, `${FN} → params.consent`);
    if (params.consent.hashes !== undefined) {
      ensureArrayOfStrings(params.consent.hashes, `${FN} → params.consent.hashes`);
    }
    if (params.consent.metadata !== undefined && params.consent.metadata !== null) {
      ensureObject(params.consent.metadata, `${FN} → params.consent.metadata`);
    }
  }

  const nl = params.newsletter;
  const optIn = nl?.receber === true;

  const body = {
    data_extension_key: DATA_EXTENSION_KEY,
    dados: [
      {
        keys: {
          email: params.email,
          turma: params.className,
          curso: params.courseName,
        },
        values: {
          usuario_id: params.email,
          nome: null,
          newsletter_pub_list_id: optIn ? nl.pubListId : null,
          newsletter_receber: optIn,
          newsletter: optIn ? nl.code : null,
        },
      },
    ],
  };

  const apiPromise = request(CURSOS_ALL_UPSERT_URL, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(body),
  });

  const consentPromise: Promise<boolean> = params.consent
    ? privacyConsent({ ...params.consent, holder: params.email })
    : Promise.resolve(true);

  const [apiOk, consentOk] = await Promise.all([apiPromise, consentPromise]);
  return apiOk && consentOk;
}
